import { render, staticRenderFns } from "./NVDModalTabs.vue?vue&type=template&id=40e8e72b&"
import script from "./NVDModalTabs.vue?vue&type=script&lang=ts&"
export * from "./NVDModalTabs.vue?vue&type=script&lang=ts&"
import style0 from "./NVDModalTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40e8e72b', component.options)
    } else {
      api.reload('40e8e72b', component.options)
    }
    module.hot.accept("./NVDModalTabs.vue?vue&type=template&id=40e8e72b&", function () {
      api.rerender('40e8e72b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/NVDModalTabs.vue"
export default component.exports